import HeroSection from '../../components/HeroSection';
import ancileGRCImage from '../../assets/images/ancile-data-compliance.png';

const AncileGRC = () => {

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <HeroSection
        title="Ancile GRC"
        subtitle = "Unlock Unrivaled GRC Efficiency"
        description="Transform your governance, risk, and compliance with Ancile's intelligent platform, delivering real-time insights, automated workflows, and comprehensive visibility to streamline operations and enhance decision-making."
        image={ancileGRCImage}
        hideImage={window.innerWidth < 768}
        isDataSheet={true}
        dataSheetLink={"/assets/documents/AncileGRCDataSheet.pdf"}
      />


      <div className="container mx-auto px-4 py-16">

         {/* GRC Pillars */}
      <section className="py-12 px-6 bg-white">
        <h3 className="text-3xl font-bold text-center text-gray-800 mb-10 font-poppins">
          Our Comprehensive GRC Pillars
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {[
            {
              icon: "🔍",
              title: "Audit Management",
              features: [
                "Smart audit planning",
                "Automated testing",
                "Business continuity",
                "Advanced reporting",
              ],
            },
            {
              icon: "🎯",
              title: "Risk Management",
              features: [
                "Smart risk assessments",
                "Dynamic risk scoring",
                "Predictive analytics",
                "Real-time monitoring",
              ],
            },
            {
              icon: "📋",
              title: "Compliance Management",
              features: [
                "Regulatory tracking",
                "Policy management",
                "Internal controls",
                "Vendor management",
              ],
            },
            
          ].map((mod, i) => (
            <div
              key={i}
              className="bg-white border-2 border-gray-100 rounded-xl p-6 shadow hover:shadow-lg transition-all flex flex-col items-center"
            >
              <div className="text-4xl mb-3">{mod.icon}</div>
              <div className="font-semibold text-lg text-gray-800 mb-2">
                {mod.title}
              </div>
              <ul className="list-disc list-inside text-gray-500 text-sm text-left space-y-1">
                {mod.features.map((f, j) => (
                  <li key={j}>{f}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </section>

      {/* Platform Capabilities */}
      <section className="bg-gradient-to-br from-[#f8f9ff] to-white py-12 px-6">
        <h3 className="text-3xl font-bold text-center text-gray-800 mb-10 font-poppins">
          Powerful Platform Capabilities
        </h3>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-3xl mx-auto">
          {[
            { emoji: "📊", label: "Smart Analytics" },
            { emoji: "🤖", label: "Intelligent Automation" },
            { emoji: "⚡", label: "Real-time Monitoring" },
            { emoji: "📈", label: "Advanced Reporting" },
            { emoji: "🔐", label: "Robust Cloud Security" },
            { emoji: "🔗", label: "Seamless Integrations" },
            { emoji: "🧠", label: "Risk Intelligence" },
            { emoji: "🧰", label: "SIEM Integrations" },
          ].map((feat, i) => (
            <div
              key={i}
              className="bg-white rounded-lg border border-gray-100 p-5 flex flex-col items-center text-center shadow-sm hover:border-blue-400 transition"
            >
              <div className="text-3xl mb-2">{feat.emoji}</div>
              <div className="text-gray-700 font-medium">{feat.label}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Frameworks */}
      <section className="bg-gradient-to-br from-[#ecf0f1] to-white py-16 px-6">
  <h3 className="text-4xl font-bold text-center text-gray-800 mb-6 font-poppins">
    Extensive Cloud Framework & Regulatory Support
  </h3>
  <div className="max-w-2xl mx-auto text-center mb-10">
    <p className="text-lg text-gray-700 font-medium">
      Comprehensive support for 60+ industry frameworks across AWS and Azure environments
    </p>
  </div>
  <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-5 max-w-4xl mx-auto">
    {[
      "HIPAA",
      "GDPR",
      "NIST",
      "NYDFS",
      "SOC 2",
      "SOX",
      "ISO Standard",
      "PCI DSS",
      "CMMC",
      "and more...",
    ].map((fw, i) => (
      <div
        key={i}
        className="bg-white text-sm sm:text-base rounded-xl py-4 px-4 text-gray-800 font-semibold text-center shadow-md hover:shadow-lg hover:bg-blue-50 transition duration-200"
      >
        {fw}
      </div>
    ))}
  </div>
</section>


      {/* Benefits */}
      <section className="bg-gradient-to-br from-[#2c3e50] to-[#34495e] text-white py-12 px-6">
        <h3 className="text-3xl font-bold text-center mb-10 font-poppins">
          The Ancile GRC Advantage
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {[
            {
              icon: "🤖",
              title: "Intelligent Automation",
              desc: "Leverage advanced technology to automatically identify risks, predict compliance issues, and optimize governance processes.",
            },
            {
              icon: "🚀",
              title: "Automated Efficiency",
              desc: "Streamline workflows with intelligent automation that reduces manual effort and accelerates decision-making.",
            },
            {
              icon: "📈",
              title: "Predictive Analytics",
              desc: "Make proactive decisions with data-driven insights that forecast trends and potential issues.",
            },
            {
              icon: "🧩",
              title: "Unified Platform",
              desc: "Connect all GRC aspects in one integrated solution for holistic visibility and seamless collaboration.",
            },
          ].map((b, i) => (
            <div key={i} className="text-center">
              <div className="text-4xl mb-4">{b.icon}</div>
              <div className="text-xl font-semibold mb-2">{b.title}</div>
              <div className="text-white/90">{b.desc}</div>
            </div>
          ))}
        </div>
      </section>

      {/* Pricing */}
      {/* <section className="bg-gray-50 py-16 px-6 text-center">
  <h3 className="text-4xl font-bold mb-14 text-gray-800 font-poppins">
    Ancile GRC Pricing
  </h3>
  <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto"> */}
    {/* Core Platform Card */}
    {/* <div className="bg-gradient-to-br from-[#3498db] to-[#2980b9] text-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="text-xl font-semibold mb-4">Core Platform</div>
      <div className="text-4xl font-extrabold mb-3 tracking-tight">
        $6,500<span className="text-base font-normal"> /yr</span>
      </div>
      <p className="mb-6 text-white/90 text-sm leading-relaxed">
        Full access for up to 100 users. Includes built-in automation for evidence collection and audit readiness.
      </p>
      <ul className="space-y-3 text-white/90 text-sm ml-32">
        {['Platform Access', '100 Employees', 'Evidence Automation'].map((item, i) => (
          <li key={i} className="flex items-center gap-2">
            <span className="mt-1 w-2 h-2 rounded-full bg-white flex-shrink-0"></span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div> */}

    {/* Compliance Framework Card */}
    {/* <div className="bg-gradient-to-br from-[#3498db] to-[#2980b9] text-white rounded-2xl p-10 shadow-lg hover:shadow-xl transition-shadow duration-300">
      <div className="text-xl font-semibold mb-4">Compliance Framework</div>
      <div className="text-4xl font-extrabold mb-3 tracking-tight">
        From $2,000
      </div>
      <p className="mb-6 text-white/90 text-sm leading-relaxed">
        Choose from SOC 2, ISO 27001, HIPAA, CMMC, GDPR and more. Each integrates natively with your core platform.
      </p>
      <ul className="space-y-3 text-white/90 text-sm ml-32">
        {['One Framework', 'Plug-and-Play Setup', 'Continuous Updates'].map((item, i) => (
          <li key={i} className="flex items-start gap-2">
            <span className="mt-1 w-2 h-2 rounded-full bg-white flex-shrink-0"></span>
            <span>{item}</span>
          </li>
        ))}
      </ul>
    </div>
  </div>
</section> */}


      {/* CTA */}
      <section className="bg-gradient-to-br from-[#e74c3c] to-[#c0392b] text-white py-12 px-6 text-center">
        <h3 className="text-2xl md:text-3xl font-bold mb-4 font-poppins">
          Ready to Modernize Your GRC?
        </h3>
        <div className="text-lg mb-6">
          Discover how Ancile's intelligent platform can revolutionize your governance, risk, and compliance.
        </div>
        <button
          className="bg-white text-[#e74c3c] px-8 py-3 rounded-full font-semibold text-lg shadow hover:-translate-y-1 hover:shadow-lg transition"
          onClick={() => window.open('https://ancile.ai/contact', '_blank')}
        >
          Schedule a Demo
        </button>
      </section>
      </div>
    </div>
  );
};

export default AncileGRC; 